import React from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';
import './HoneypotField.scss';

interface HoneypotFieldProps {
  registration: UseFormRegisterReturn;
}

/**
 * Pułapka na boty: pole niewidoczne dla człowieka (poza ekranem, wyjęte z tabulacji i z drzewa
 * dostępności), które automat wypełniający cały formularz uzupełni razem z resztą. Backend odrzuca
 * rejestrację, gdy przyjdzie niepuste.
 *
 * Nazwa pola NIE MOŻE należeć do żadnej kategorii autouzupełniania (`company`/`organization`,
 * `nickname`, `phone`, adresowe, …) — przeglądarka wypełnia je także poza ekranem, więc realny
 * użytkownik dostałby 403 za cudzą robotę. Stąd neutralne `contactReason` plus jawne wyłączniki
 * menedżerów haseł; `autoComplete="off"` samo nie wystarcza, bo Chrome je często ignoruje.
 */
export const HoneypotField: React.FC<HoneypotFieldProps> = ({ registration }) => (
  <input
    {...registration}
    type="text"
    tabIndex={-1}
    autoComplete="off"
    aria-hidden="true"
    data-lpignore="true"
    data-1p-ignore="true"
    data-form-type="other"
    className="honeypot-field"
  />
);

export default HoneypotField;
